export const commonNb = {
    errors: {
        somethingWentWrong: 'Noe gikk galt!',
        defaultMessage: 'Beklager, det ser ut til å være et teknisk problem. Vennligst prøv igjen senere.',
        errorCode: 'Feilkode',
        copyErrorCode: 'Kopier feilkode',
        retryButton: 'Prøv igjen',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvc2hhcmVkL3RyYW5zbGF0aW9ucy9jb21tb24vbmIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLE1BQU0sUUFBUSxHQUFxQjtJQUN0QyxNQUFNLEVBQUU7UUFDSixrQkFBa0IsRUFBRSxnQkFBZ0I7UUFDcEMsY0FBYyxFQUFFLGtGQUFrRjtRQUNsRyxTQUFTLEVBQUUsVUFBVTtRQUNyQixhQUFhLEVBQUUsaUJBQWlCO1FBQ2hDLFdBQVcsRUFBRSxZQUFZO0tBQzVCO0NBQ0osQ0FBQyJ9